import { useState, useEffect } from "react";
import { getWord } from "../../utils/functions";
import { useSelector } from "react-redux";
import axios from "axios";
import { BASE_URL } from "../../config";
import store from "../../store/store";
import * as actionTypes from "../../store/actions";
import { LoadingButton } from "../Common/Loading";

const Profile = () => {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState({
    userId: user.userdata.id,
    fname: user.userdata.fname,
    lname: user.userdata.lname,
    email: user.userdata.email,
    phone: user.userdata.phone,
    errors: {},
    loading: false,
  });

  const { userId, fname, lname, email, phone, errors, loading } = data;

  const handleChange = (e) => {
    setData((data) => ({
      ...data,
      [e.target.name]: e.target.value.trim(),
      errors: { ...data.errors, [e.target.name]: "" },
    }));
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    setData((data) => ({
      ...data,
      errors: {},
      loading: true,
    }));
    try {
      const postData = {
        userId,
        fname,
        lname,
        email,
        phone,
      };
      console.log(postData);
      const response = await axios.post(`${BASE_URL}/user/profile`, postData);
      const result = response.data;
      if (result.message === "Success") {
        store.dispatch({
          type: actionTypes.UPDATE_USERDATA,
          payload: { userdata: result.user },
        });
        setData((data) => ({
          ...data,
          errors: { ...data.errors, error: "Updated Successfully" },
        }));
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.messages) {
        const messages = err.response.data.messages;
        Object.entries(messages).map(([field, message]) =>
          setData((data) => ({
            ...data,
            errors: { ...data.errors, [field]: message },
          }))
        );
      } else {
        setData((data) => ({
          ...data,
          errors: { ...data.errors, error: "An unexpected error occurred" },
        }));
      }
    } finally {
      setData((data) => ({ ...data, loading: false }));
    }
  };
  return (
    <>
      <div className="col-md-9">
        <div className="grid-layout wrapper-shop">
          <div className="tf-login-content">
            <div className="tf-page-cart-item">
              <form
                className="form-checkout"
                onSubmit={handleUpdate}
                autoComplete="off"
              >
                <div className="box grid-2">
                  <fieldset className="fieldset">
                    <label htmlFor="fname">{getWord("First Name")}</label>
                    <input
                      autoComplete="off"
                      type="text"
                      id="fname"
                      name="fname"
                      value={fname}
                      onChange={handleChange}
                    />
                    {errors.fname && (
                      <div className="error">{errors.fname}</div>
                    )}
                  </fieldset>
                  <fieldset className="fieldset">
                    <label htmlFor="lname">{getWord("Last Name")}</label>
                    <input
                      autoComplete="off"
                      type="text"
                      id="lname"
                      name="lname"
                      value={lname}
                      onChange={handleChange}
                    />
                    {errors.lname && (
                      <div className="error">{errors.lname}</div>
                    )}
                  </fieldset>
                </div>
                <div className="box grid-2">
                  <fieldset className="fieldset">
                    <label htmlFor="email">{getWord("Email")}</label>
                    <input
                      autoComplete="off"
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="error">{errors.email}</div>
                    )}
                  </fieldset>
                  <fieldset className="fieldset">
                    <label htmlFor="phone">{getWord("Phone Number")}</label>
                    <input
                      autoComplete="off"
                      type="text"
                      id="phone"
                      name="phone"
                      value={phone}
                      onChange={handleChange}
                    />
                    {errors.phone && (
                      <div className="error">{errors.phone}</div>
                    )}
                  </fieldset>
                </div>
                <div className="box fieldset">
                  <button className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center">
                    {loading ? <LoadingButton></LoadingButton> : ""}
                    {getWord("Update")}
                  </button>
                  {errors.error && <div className="error">{errors.error}</div>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
